/* The localStorage.js file make the data persistent within the local storage */

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('picourt-app');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('picourt-app', serializedState);
  } catch {
    // ignore write errors
  }
}
